module.exports = __webpack_public_path__ + "static/img/yn1.83100bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/yn1.jpg
// module id = GRko
// module chunks = 0